import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Sticker from 'design-system/components/Sticker';

const DataSticker = styled('span')`
  margin-right: auto;
  padding-left: ${Spacing[2]};
  cursor: pointer;
`;

interface SimulatedDataStickerProps {
  dataSectionLabel: string;
}

export const SimulatedDataSticker = ({ dataSectionLabel }: SimulatedDataStickerProps) => {
  return (
    <DataSticker>
      <Sticker data-test={`simulated-data__${dataSectionLabel}`} variant='orange'>
        Simulated Data
      </Sticker>
    </DataSticker>
  );
};
